<template>
  <span class="help is-danger has-text-left">
    <!--<slot></slot>-->
    <li v-for="info in infos">{{ info.message }}</li>
  </span>
</template>

<script>
export default {
  props: ['error'],
  computed: {
    infos () {
      let infos = []
      for (let i = 0; i < this.error.length; i++) {
        infos.push({
          message: this.error[i]
        })
      }
      return infos
    }
  }
}
</script>

<style>
.help {
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// FormError.vue?477d551f